let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kmg1H")).then(() => parcelRequire('foJCE'));